import { createAsyncThunk } from '@reduxjs/toolkit';
import { restructureErrorMessage } from '../../helpers/errorMessage';
import jomPayPaymentService from './jomPayPaymentService';

export const getJomPayPaymentThunk = createAsyncThunk(
  'jomPayPayment/getJomPayPayment',
  async (requestData: any, thunkAPI) => {
    try {
      return await jomPayPaymentService.getJomPayPayment(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
